// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import * as z from 'zod'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_LiabilityV1GetsafeDe = z.object({
  zip_code: z
    .string()
    .min(1)
    .regex(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/),
  tariff_line: z.enum(['comfort', 'premium']),
  drones_coverage: z.boolean(),
  family_coverage: z.boolean(),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '150', '300']))
    .pipe(z.coerce.number()),
  number_of_claims_in_last_5y: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number())
    .optional(),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  previous_insurance_in_last_5y: z.boolean(),
})

const Schema_LiabilityV1GetsafeDe = BaseSchema_LiabilityV1GetsafeDe.superRefine((values, ctx) => {
  if (
    values['previous_insurance_in_last_5y'] !== undefined &&
    [true].includes(values['previous_insurance_in_last_5y'])
  ) {
    if (values['number_of_claims_in_last_5y'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'integer',
        received: 'undefined',
        message: 'Required',
        path: ['number_of_claims_in_last_5y'],
      })
    }
  }
}).superRefine((values, ctx) => {
  if (
    values['previous_insurance_in_last_5y'] !== undefined &&
    [true].includes(values['previous_insurance_in_last_5y'])
  ) {
    if (values['cancelled_by_previous_insurer'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'boolean',
        received: 'undefined',
        message: 'Required',
        path: ['cancelled_by_previous_insurer'],
      })
    }
  }
})

export default Schema_LiabilityV1GetsafeDe
